function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "14.479,71.85 18.862,82.335 22.045,83.268 32.668,105.049 44.356,103.462 53.787,117.671  54.051,125.632 58.438,137.188 59.099,142.502 66.269,156.438 71.318,156.711 72.644,166.67 85.131,168.933 88.314,177.963  86.457,183.536 90.17,183.536 99.337,180.613 102.125,187.12 107.435,190.84 112.748,190.174 114.343,200 118.331,192.161  118.587,161.355 122.44,146.089 128.021,140.239 132.399,139.578 130.943,137.188 133.732,122.714 139.311,120.716 146.881,112.352  147.811,108.367 152.592,106.38 172.644,110.092 184.595,108.367 186.189,101.467 185.53,93.895 177.423,77.688 171.05,92.827  165.733,89.239 157.234,90.174 145.688,71.85 147.274,67.202 150.333,67.202 146.881,59.227 152.592,47.678 151.659,35.458  154.45,25.496 146.881,13.548 143.825,10.889 130.943,7.707 123.64,7.707 119.252,11.558 112.217,23.245 108.1,22.847  106.248,18.858 99.607,16.203 93.623,18.592 89.508,15.938 86.985,15.938 83.933,18.858 71.583,9.297 59.099,0.665 56.84,0  54.718,3.717 52.192,2.654 48.075,7.968 49.004,14.209 46.215,17.928 41.434,18.191 39.303,18.858 40.907,27.492 36.782,33.067  35.854,44.76 27.361,48.338 15.667,47.284 13.811,60.562 "
});

var Svg10 = function Svg10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DGO",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/10.cff0569f.svg";
export { ForwardRef as ReactComponent };